import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  flytLogo: {
    display: 'flex',
    alignItems: 'center'
  }
}));